@if (!vm.categoryCode) {
  <app-skeleton-loader class="dark full-width max-w-120 h-40 sm-h-32" />

  <app-skeleton-loader class="dark full-width h-40 sm-h-32 mt-24 sm-mt-16" />
  <app-skeleton-loader class="dark full-width h-40 sm-h-32 mt-8" />
  <app-skeleton-loader class="dark full-width h-40 sm-h-32 mt-8" />
} @else {
  <app-button
    dataLabel="see-faqs"
    [class.full-width]="vm.questions.length === 0"
    [buttonOptions]="{
      variant: 'link',
      fill: vm.questions.length === 0,
      isLink: true,
      url: 'https://www.domesticandgeneral.com/content/help-advice-section/faq',
    }"
  >
    <span>See more help and advice</span>
    <i class="fa-light fa-arrow-right ml-4"></i>
  </app-button>

  @if (vm.questions.length) {
    <section class="flex-col mt-28 sm-mt-20 gap-8">
      @for (question of vm.questions; track question.question; let index = $index; let first = $first) {
        <section class="panel" [class.open]="vm.openPanels[index]">
          <section class="header">
            <button class="block full-width label p-16" (click)="updateOpenPanels(index)">
              {{ question.question }}

              <i
                class="fa-light ml-8"
                [class.fa-chevron-up]="vm.openPanels[index]"
                [class.fa-chevron-down]="!vm.openPanels[index]"
              ></i>
            </button>
          </section>

          <section [appAnimateOpen]="vm.openPanels[index]" class="content">
            <section class="flex-col pl-16 pr-16 pb-16 gap-8 full-width max-w-496">
              @for (answer of question.answer; track answer) {
                <p class="body">
                  {{ answer }}
                </p>
              }
            </section>
          </section>
        </section>
      }
    </section>
  }
}
